import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import QuotesAdminView from './QuotesAdminView';
import QuoteDetailView from './QuotesDetail';

const QuotesView = () => (
  <Routes>
    <Route path="detail/:id/*" element={<QuoteDetailView />} />
    <Route path=":tab" element={<RolePrivateRoute component={QuotesAdminView} />} />
    <Route index element={<RolePrivateRoute component={QuotesAdminView} />} />
  </Routes>
);

export default QuotesView;
